import { Component, ChangeDetectionStrategy, computed, inject } from '@angular/core';

import { IrisFoldersService } from '@iris/common/services/docs/folders.service';
import { DmsBaseFolderAction } from '../dms-base-folder-action';
import { IrisDmsFoldersSandbox } from '@iris/common/modules/dms/sandbox/dms-folders.sandbox';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, switchMap } from 'rxjs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgClass } from '@angular/common';
import { MatMenuItem } from '@angular/material/menu';
import { StrakitButtonComponent } from '@ngx-strakit/cdk/controls';
import { StrakitButtonPrefixDirective } from '@ngx-strakit/cdk';

@Component({
  selector: 'iris-dms-download-folder-button',
  templateUrl: './dms-download-folder-button.component.html',
  styleUrls: ['./dms-download-folder-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgClass,
    MatTooltipModule,
    MatMenuItem,
    StrakitButtonComponent,
    StrakitButtonPrefixDirective,
  ],
})
export class IrisDmsDownloadFolderButtonComponent extends DmsBaseFolderAction {
  private readonly foldersService = inject(IrisFoldersService);
  private readonly dmsFoldersSandbox = inject(IrisDmsFoldersSandbox);

  protected _label = 'label.Download';

  private readonly folder = toSignal(this.folderId$.pipe(
    filter(Boolean),
    switchMap(folderId => this.dmsFoldersSandbox.getFolderById$(folderId)),
  ));
  private readonly folderName = computed(() => this.folder()?.name);

  downloadFolder(): void {
    this.foldersService.downloadFolder(this.folderId(), this.folderName()).subscribe();
  }
}
